export default "__VITE_ASSET__CcY3g$uC__"